import { render, staticRenderFns } from "./stockMovementDescriptionColumn.vue?vue&type=template&id=4cf399f2&"
import script from "./stockMovementDescriptionColumn.vue?vue&type=script&lang=ts&"
export * from "./stockMovementDescriptionColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports